import { SegmentFieldItem } from 'utils/segment-field-item.interface';

/* eslint-disable */
export const attributesSegmentData: Array<SegmentFieldItem> = [
  // only for PAdb
  {
      "field_map": "assignment_id",
      "item_name": "assignment_id",
      "title": "Attribute assignment ID",
      "hint_detail": "Attribute assignment ID",
      "sequence": 1,
  },
  {
      "field_map": "attribute_id",
      "item_name": "attribute_id",
      "title": "Attribute ID",
      "hint_detail": "Attribute ID",
      "sequence": 1,
  },
  {
      "field_map": "name",
      "item_name": "name",
      "title": "Attribute Label",
      "hint_detail": "Either industry-defined attributes from the Product Attribute Database (PAdb), or user-defined attributes. Delivered in the sequence shown here.",
      "hint_panel" : "Either industry-defined attributes from the Product Attribute Database (PAdb), or user-defined attributes. Delivered in the sequence shown here.",
      "example": "Material",
      "sequence": 1,
      "show_more": true,
      "lookup": null,
      'validation': {
        'pies65': {
          required: true,
          minLength: 1,
          maxLength: 80,
          message: "Attribute name cannot be longer than 80 characters."
        }
      }
  },
  {
      "field_map": "value",
      "item_name": "value",
      "title": "Attribute Value",
      "type": "list",
      "hint_detail": "Value of the attribute",
      "hint_panel" : "Value of the attribute. If the attribute value is a measurement of some type (e.g., weight, diameter, thickness, etc.) do not combine the unit of measure with the value like '1.5 in.' Please use the Units to define the unit of measure.",
      "example": "Aluminum",
      "sequence": 2,
      "show_more": true,
      "lookup": null,
      'validation': {
        'pies65': {
          required: true,
          minLength: 1,
          maxLength: 2000,
          message: "Attribute value cannot be longer than 2000 characters."
        }
      }
  },
  {
      "field_map": "is_padb",
      "item_name": "is_padb",
      "title": "Is PAdb",
      "hint_detail": "Is PAdb",
      "sequence": 2,
      "show_more": true,
      "lookup": null,
  },
  {
      "field_map": "uom_label",
      "item_name": "uom_label",
      "title": "Units",
      "hint_detail": "Unit of measure",
      "hint_panel" : "Select a standard PAdb attribute and standard unit of measure.",
      "example": "",
      "sequence": 3,
      "show_more": true,
      "lookup": null,
  },
  {
      "field_map": "uom",
      "item_name": "uom",
      "title": "Units",
      "hint_detail": "Unit of measure",
      "hint_panel" : "Select a standard PAdb attribute and standard unit of measure.",
      "example": "",
      "sequence": 3,
      "show_more": true,
      "lookup": null,
  },
  {
      "field_map": "uom_description",
      "item_name": "uom_description",
      "title": "Units",
      "hint_detail": "Unit of measure",
      "hint_panel" : "Select a standard PAdb attribute and standard unit of measure.",
      "example": "",
      "sequence": 3,
      "show_more": true,
      "lookup": null,
  },
  // only for PAdb
  {
      "field_map": "style_id",
      "item_name": "style_id",
      "title": "Style",
      "hint_detail": "Style can represent a variation in the construction of a part or different performance characteristics.",
      "hint_panel" : "Select a standard style which can represent a variation in the construction of a part or different performance characteristics.",
      "example": "",
      "sequence": 5,
      "show_more": true,
      "lookup": null,
      'validation': {
        'pies65' : {
          required: true,
          maxLength: 48
        }
      }
  },
  {
      "field_map": "style_name",
      "item_name": "style_name",
      "title": "Style",
      "hint_detail": "Style can represent a variation in the construction of a part or different performance characteristics.",
      "hint_panel" : "Select a standard style which can represent a variation in the construction of a part or different performance characteristics.",
      "example": "",
      "sequence": 6,
      "show_more": true,
      "lookup": null,
  },
  {
    "field_map": "description",
    "item_name": "description",
    "title": "Description",
    "hint_detail": "Description",
    "example": "Description",
    "sequence": 1,
    "show_more": true,
    "lookup": null,
  },
  // only for PAdb
  {
    "field_map": "valid_attribute_values",
    "item_name": "valid_attribute_values",
    "title": "Valid attribute values",
    "hint_detail": "Valid attribute values",
    "sequence": 1,
    "show_more": true,
    "lookup": null,
  },
  // only for PAdb
  {
    "field_map": "meta_uom_codes",
    "item_name": "meta_uom_codes",
    "title": "Meta uom codes",
    "hint_detail": "Meta uom codes",
    "sequence": 1,
    "show_more": true,
    "lookup": null,
  },
  // only for PAdb
  {
    "field_map": "styles",
    "item_name": "styles",
    "title": "Styles",
    "hint_detail": "Styles",
    "sequence": 1,
    "show_more": true,
    "lookup": null,
  },
  // only for PAdb
  {
    "field_map": "meta_data",
    "item_name": "meta_data",
    "title": "Meta data",
    "hint_detail": "Meta data",
    "sequence": 1,
    "show_more": true,
    "lookup": null,
  },
];
/* eslint-enable */
